import { render, staticRenderFns } from "./AdBox.vue?vue&type=template&id=a61ee85c&scoped=true&lang=pug&"
import script from "./AdBox.vue?vue&type=script&lang=js&"
export * from "./AdBox.vue?vue&type=script&lang=js&"
import style0 from "./AdBox.vue?vue&type=style&index=0&id=a61ee85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61ee85c",
  null
  
)

export default component.exports